import React from "react";
import { NavLink, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, CalendarDays, Presentation, Users, Newspaper,
  Handshake, ClipboardList, Image, Settings, ShieldCheck, LogOut, ExternalLink, ScanLine,
} from "lucide-react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "admin-nav-dashboard" },
  { to: "/admin/registrations", label: "Inscriptions", icon: ClipboardList, testid: "admin-nav-registrations" },
  { to: "/admin/checkin", label: "Check-in", icon: ScanLine, testid: "admin-nav-checkin" },
  { to: "/admin/editions", label: "Éditions", icon: CalendarDays, testid: "admin-nav-editions" },
  { to: "/admin/conferences", label: "Programme", icon: Presentation, testid: "admin-nav-conferences" },
  { to: "/admin/speakers", label: "Intervenants", icon: Users, testid: "admin-nav-speakers" },
  { to: "/admin/articles", label: "Articles", icon: Newspaper, testid: "admin-nav-articles" },
  { to: "/admin/partners", label: "Partenaires", icon: Handshake, testid: "admin-nav-partners" },
  { to: "/admin/media", label: "Médias", icon: Image, testid: "admin-nav-media" },
  { to: "/admin/settings", label: "Réglages & SEO", icon: Settings, adminOnly: true, testid: "admin-nav-settings" },
  { to: "/admin/users", label: "Utilisateurs", icon: ShieldCheck, adminOnly: true, testid: "admin-nav-users" },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";

  const doLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen flex bg-f2b-light">
      <aside className="w-64 bg-f2b-black text-white flex flex-col fixed h-screen" data-testid="admin-sidebar">
        <div className="p-6 border-b border-white/10">
          <img src="/brand/f2b-logo-light.png" alt="FACADES2build" className="h-9 w-auto" />
          <p className="f2b-kicker text-f2b-gray mt-2">Back-office</p>
        </div>
        <nav className="flex-1 py-4 overflow-y-auto">
          {nav.filter((n) => !n.adminOnly || isAdmin).map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testid}
              className={({ isActive }) => `flex items-center gap-3 px-6 py-3 text-sm transition-colors ${isActive ? "bg-f2b-cyan/10 text-f2b-cyan border-r-2 border-f2b-cyan" : "text-white/70 hover:text-white hover:bg-white/5"}`}>
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-2 py-2 text-sm text-white/60 hover:text-f2b-cyan"><ExternalLink size={16} /> Voir le site</a>
          <div className="flex items-center gap-3 px-2 py-3 mt-2 border-t border-white/10">
            <div className="w-8 h-8 rounded-full bg-f2b-cyan/20 flex items-center justify-center text-f2b-cyan text-xs font-bold shrink-0">
              {(user?.name || "?").slice(0, 1)}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm truncate">{user?.name}</p>
              <p className="text-xs text-f2b-gray capitalize">{user?.role === "admin" ? "Administrateur" : "Éditeur"}</p>
            </div>
            <button onClick={doLogout} data-testid="admin-logout" className="text-white/60 hover:text-f2b-cyan" aria-label="Déconnexion"><LogOut size={18} /></button>
          </div>
        </div>
      </aside>
      <div className="flex-1 ml-64 min-h-screen">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
